"use client";
import { jsx as o } from "react/jsx-runtime";
import t from "@mui/material/GlobalStyles";
import { CarMaxSharpSansDispBold as l, Lato as a, LatoBold as s } from "./fontFaces.js";
const m = () => /* @__PURE__ */ o(t, { styles: [l, a, s] });
export {
  m as default
};
